import "./style.scss";
import * as React from "react";

import { Checkbox } from "../../../form";
import { Popover, Icon } from "antd";
import Section from "../../../core/Section";
import Row from "../../../core/Row";
import Button from "../../../core/Button";
import SendNowPopover from "./SendNowPopover";
import Feature from "../../../common/components/Feature";

class ReportReview extends React.Component<any, any> {
  constructor() {
    super();
    this.state = {
      sendCopy: false
    };
  }

  toggleSendCopy() {
    this.setState(prevState => ({ sendCopy: !prevState.sendCopy }));
  }

  handleBackButton() {
    this.props.back();
  }

  render() {
    return (
      <div className="report-review">
        <Section className="report-review" title="Report Review">
          <Row>
            <span className="left">Filename</span>
            <span className="right">{this.props.filename}</span>
          </Row>
          <Row>
            <span className="left">File Format</span>
            <span className="right">{this.props.format}</span>
          </Row>
          <Row>
            <span className="left">Compressed</span>
            <span className="right">{this.props.compressed}</span>
          </Row>
          <Row>
            <span className="left"># of days to report on</span>
            <span className="right">{this.props.duration}</span>
          </Row>
          <Row>
            <span className="left">Grouped By</span>
            <span className="right">{this.props.dimensions}</span>
          </Row>
          <Row>
            <span className="left">Metric(s)</span>
            <span className="right">{this.props.metrics}</span>
          </Row>
          <Row>
            <span className="left">Delivery Destination(s)</span>
            <span className="right">{this.props.endpoint}</span>
          </Row>
          <Row>
            <span className="left">Automated Export Schedule</span>
            <span className="right">{this.props.schedule}</span>
          </Row>
          <Row>
            <span className="left">Enabled</span>
            <span className="right">{this.props.enabled}</span>
          </Row>
          <Row>
            <span className="left">Email Notification</span>
            <span className="right">{this.props.contacts}</span>
          </Row>
          <Feature flag="apr_3_admin">
            <div>
              <Row></Row>
              <Row>
                <span className="left">
                  Send a copy of this report right away?
                  <Popover
                    content={SendNowPopover}
                    title="Help"
                    trigger="hover"
                  >
                    <Icon type="question-circle" />
                  </Popover>
                </span>
                <div className="right">
                  <Checkbox
                    checked={this.state.sendCopy}
                    handleChange={() => this.toggleSendCopy()}
                  />
                </div>
              </Row>
            </div>
          </Feature>
        </Section>

        <Button
          type="primary"
          onClick={() => this.props.next(this.state.sendCopy)}
          className="submit"
        >
          Save
        </Button>

        <Button
          type="primary"
          onClick={this.handleBackButton.bind(this)}
          className="back"
        >
          Back
        </Button>
      </div>
    );
  }
}

export default ReportReview;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/ReportReview/component.tsx